import React from 'react';

/**
 * Placeholder so the marketing app compiles without the full
 * events-calculator copy from seamlesslyUs.
 */
const EventSpacesCalculator = () => (
  <section className="ledger-section">
    <div className="wrap">
      <div className="section-head">
        <span className="eyebrow">The Math</span>
        <h2>Event calculator</h2>
        <p className="sub">
          Use the live estimator on the Fees page, or talk to us for a full breakdown.
        </p>
      </div>
    </div>
  </section>
);

export default EventSpacesCalculator;
